export default "__VITE_ASSET__DwdI2pbS__"